import React from 'react';
import { FaUsers, FaUserAlt } from 'react-icons/fa';
import { AiTwotoneHome } from 'react-icons/ai';
import { useFirebaseData } from '../../hooks/useFirebaseData';

const iconMap = {
  'MEMBERS': <FaUsers />,
  'PASTORS': <FaUserAlt />,
  'PARTNERS': <FaUserAlt />,
  'CHURCHES': <AiTwotoneHome />
};

export default function DonationData() {
  const { data: statisticsData, loading } = useFirebaseData('statistics');

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className='grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 px-4 lg:px-0'>
      {statisticsData.map((item, index) => (
        <div key={index} className='flex flex-col items-center justify-center bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300'>
          <div className='text-4xl text-[#ffd615] mb-4'>
            {iconMap[item.title] || <FaUsers />}
          </div>
          <div className='text-2xl font-bold text-gray-800 mb-2'>
            {item.number}
          </div>
          <div className='text-sm text-gray-600 uppercase tracking-wider'>
            {item.title}
          </div>
        </div>
      ))}
    </div>
  );
} 